import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { HtmlFromTextPipe } from 'src/app/shared/pipe/html-from-text.pipe';
import { SCREEN_ASPECT_CONVERTER } from 'src/app/shared/util/sreen-apect-converter';

@Component({
  selector: 'app-text-content',
  templateUrl: './text-content.component.html',
  styleUrls: ['./text-content.component.scss'],
  providers: [HtmlFromTextPipe]
})
export class TextContentComponent implements AfterViewInit {

  @ViewChild('svgRef') svgRef: ElementRef;

  @Input() textContent: string;

  ngAfterViewInit(): void {
    this.setBaseTextViewBox();
  }

  private setBaseTextViewBox(): void {
    let baseScreenWidth: number = window.screen.width;
    const baseScreenHeight: number = window.screen.height;
    if (baseScreenWidth > baseScreenHeight * SCREEN_ASPECT_CONVERTER)
      baseScreenWidth = baseScreenHeight * SCREEN_ASPECT_CONVERTER;
    let height: number = baseScreenWidth / SCREEN_ASPECT_CONVERTER;
    height = height - (height * 0.2);
    const width: number = height * SCREEN_ASPECT_CONVERTER;
    this.svgRef.nativeElement.setAttribute('viewBox', `0 0 ${width} ${height}`);
  }
}
